export default __webpack_public_path__ + "static/media/news-cover.a68456f0.png";